<template>
    <div class="container">
        <ais-instant-search
                :search-client="searchClient"
                index-name="documents"
                :routing="routing"
        >
            <div class="search-panel">
                <div class="search-panel__results">
                    <ais-search-box placeholder="Keresendő szöveg" class="searchbox"/>
                    <ais-configure :hits-per-page.camel="20" />
                    <ais-configure :attributesToSnippet="['content']"/>

                  <div class="row">
                      <div class="ais-PoweredBy col-md-6"></div>
                        <ais-stats
                                :class-names="{
                            'ais-Stats': 'col-md-6 text-md-right'
                          }" >
                            <p slot-scope="{ nbPages, nbHits, page }">
                                {{ nbHits }} dokumentum. {{ page + 1 }}/{{ nbPages }} oldal.
                            </p>
                        </ais-stats>

                        <!--ais-refinement-list attribute="type"/-->
                        <ais-numeric-menu
                                attribute="date"
                                :items="[
                                { label: 'Összes' },
                                { label: '2014', start: 1388534400, end: 1420070399 },
                                { label: '2015', start: 1420070400, end: 1451606399 },
                                { label: '2016', start: 1451606400, end: 1483228799 },
                                { label: '2017', start: 1483228800, end: 1514764799 },
                                { label: '2018', start: 1514764800, end: 1546300799 },
                                { label: '2019', start: 1546300800, end: 1577836799 },
                                { label: '2020', start: 1577836800, end: 1609459199 },
                                { label: '2021', start: 1609459200, end: 1640995199 },
                                { label: '2022', start: 1640995200, end: 1672531199 },
                                { label: '2023', start: 1672531200, end: 1704067199 },
                              ]"
                                :class-names="{
                                'ais-NumericMenu': 'col-12'
                              }"
                        >
                            <div slot-scope="{ items, refine }">
                                    <button v-for="item in items" :key="item.value" :class="'m-1 btn btn-info' + (item.isRefined ? ' active' : '')" @click.prevent="refine(item.value)" type="button" class="btn btn-info">
                                        {{ item.label }}
                                    </button>
                            </div>
                        </ais-numeric-menu>
                    </div>
                    <ais-hits>
                        <div slot-scope="{ items }" :class="'row'">
                            <div v-for="item in items" :key="item.id" :class="'col-sm-12 col-md-6 col-lg-3 mb-2'">
                                <div :class="'card h-100'">
                                    <div class="card-body">
                                        <h3 class="card-title">
                                            <a :href="'https://static.karancssag.info/download/' + item.file">
                                                <ais-highlight :hit="item" attribute="title"/>
                                            </a>
                                        </h3>
                                        <p class="card-text">
                                            <ais-snippet attribute="content" :hit="item"/>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ais-hits>

                    <div class="pagination">
                        <ais-pagination/>
                    </div>
                </div>
            </div>
        </ais-instant-search>
    </div>
</template>

<script>
    import algoliasearch from 'algoliasearch/lite';
    import 'instantsearch.css/themes/algolia-min.css';
    import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
    import { simple as simpleMapping } from 'instantsearch.js/es/lib/stateMappings';

    import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";

    const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
      server: {
        apiKey: "w7TZnSK4Qe5fsbaMgYQmZ8eWwpFqQf1n", // Be sure to use an API key that only allows search operations
        nodes: [
          {
            host: "ts.karancssag.info",
            path: "", // Optional. Example: If you have your typesense mounted in localhost:8108/typesense, path should be equal to '/typesense'
            port: "443",
            protocol: "https",
          },
        ],
        cacheSearchResultsForSeconds: 2 * 60, // Cache search results from server. Defaults to 2 minutes. Set to 0 to disable caching.
      },
      // The following parameters are directly passed to Typesense's search API endpoint.
      //  So you can pass any parameters supported by the search endpoint below.
      //  query_by is required.
      additionalSearchParameters: {
        query_by: "title,content",
        group_by: "file",
        group_limit: 1
      },
    });

    //const searchClient = typesenseInstantsearchAdapter.searchClient;

    export default {
        data() {
            return {
                // searchClient: algoliasearch(
                //     'S7KHQ09X66',
                //     'b413388f2713555e48cba28b1006c664'
                // ),
                searchClient: typesenseInstantsearchAdapter.searchClient,
                routing: {
                    router: historyRouter(),
                    stateMapping: simpleMapping(),
                }
            };
        },
    };

</script>
